import { getRatingBand } from '@core/constants/chips/ratings.constants';

export const SarbQuestionsColumns = [
    {
        displayName: 'Question',
        sortColumnName: 'sarbQuestionId',
        dataType: 'string',
        dataKey: 'questionNumber',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-5',
    },
    {
        displayName: 'Paragraph',
        sortColumnName: 'paragraph',
        dataType: 'string',
        dataKey: 'paragraph',
        settings: { sort: false, filter: false, multiple: false },
        css: 'w-10',
    },
    {
        displayName: 'Principle',
        sortColumnName: 'principleName',
        dataType: 'string',
        dataKey: 'principleName',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-15',
    },
    {
        displayName: 'Question',
        sortColumnName: 'questionText',
        dataType: 'string',
        dataKey: 'questionText',
        settings: { sort: false, filter: false, multiple: false },
    },
    {
        displayName: 'Rating',
        sortColumnName: 'rating',
        dataType: 'indicator-chip',
        dataKey: 'rating',
        // Rating is now a decimal (e.g. 3.6, no longer rounded to a whole number), so the chip
        // shows the actual value rather than a "N - Label" word that would no longer make sense
        // for a continuous value - the colour still comes from the band (see getRatingBand).
        converter: (rating) => {
            const band = getRatingBand(rating);
            const text = rating ? Number(rating).toFixed(1) : 'Not Assessed';
            return { label: { text }, value: rating ?? 0, css: band.css };
        },
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-10',
    },
];

export const SarbQuestionsTableFilters = (paginationEvent, paginationData, sortCallback) => ({
    sorting: {
        sortByColumn: 'sarbQuestionId',
        sortByDescending: false,
        callback: sortCallback,
    },
    pagination: {
        paginationEvent,
        paginationData,
        pageSizeOptions: [
            { value: 10, text: '10' },
            { value: 25, text: '25' },
            { value: 50, text: '50' },
        ],
        defaultPageSize: { value: 10, text: '10' },
    },
});
